import { Typography } from "@cappelendamm/design-system/react";
import Contributor from "@/utils/contributor.svg";
import Image from "next/image";
import classNames from "classnames";
import type { ComponentProps, ReactNode } from "react";

type ContributorCardProps = ComponentProps<"div"> & {
  contributorRole?: string;
  description: ReactNode;
  image?: { src?: string | null; altText?: string };
};

export function ContributorCard({
  contributorRole,
  description,
  image,
  className,
  style,
}: ContributorCardProps) {
  return (
    <div
      className={classNames(
        "grid w-fit grid-cols-[auto_minmax(100px,65ch)] gap-4 rounded-xl bg-surface-100 p-4 sm:gap-x-6 sm:p-6",
        { "grid-rows-[1fr_auto]": contributorRole },
        className,
      )}
      style={style}
    >
      {image?.src ? (
        <Image
          alt={image.altText ?? ""}
          src={image.src}
          height={100}
          width={100}
          placeholder="empty"
          className="aspect-square rounded object-cover"
        />
      ) : (
        <Contributor className="aspect-square h-[100px] w-[100px] text-gray-200 grayscale" />
      )}
      {contributorRole ? (
        <Typography
          variant="body-sm-tight"
          className="col-start-1 text-center uppercase"
        >
          {contributorRole}
        </Typography>
      ) : null}
      <div className="-col-end-1 row-span-full flex items-center">
        <div
          className={classNames(
            "prose text-left",
            contributorRole ? "line-clamp-5" : "line-clamp-3",
          )}
        >
          {description}
        </div>
      </div>
    </div>
  );
}
